import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import PdfRenderWidgets from '../../widgets/pdfWidgets/PdfRenderWidgets'
import { startLoading, doneLoading } from '../../utils/loading'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getProposalForm, getProposalPreviewForm } from '../../redux/actions/filesManagement'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { ERR_MSG_404_PROJECT_ID } from '../../constants/msgText'

export default function PreviewBeforePrint(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [isPDFLoading, setIsPDFLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  const [filePDF, setFilePDF] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //mock schema
      let _schema = await getProposalPreviewForm(projectId)
      //call api get pdf
      setSchemas(_schema)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  const handleGetPDF = async () => {
    setIsPDFLoading(true)
    try {
      const filePDF = await getProposalForm(projectId)
      setFilePDF(filePDF)
    } catch (e) {}

    setIsPDFLoading(false)
  }

  useEffect(() => {
    if (projectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  useEffect(() => {
    schemas && handleGetPDF()
  }, [schemas])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {schemas?.forms?.showBeforePrint && (
          <>
            <PdfRenderWidgets
              header={schemas.forms.showBeforePrint.header}
              file={filePDF}
              fileName={schemas.projecCode}
              isLoading={isPDFLoading}
            />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
